"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TablePagination_1 = require("./TablePagination");
const { toolbar, spacer } = TablePagination_1.tablePaginationClasses;
const MuiTablePaginationOverrides = {
    MuiTablePagination: {
        defaultProps: {
            labelDisplayedRows: ({ from, to, count }) => (`${from} – ${to} of ${count !== -1 ? count : `more than ${to}`}`)
        },
        styleOverrides: {
            root: ({ theme }) => ({
                [`.${spacer}`]: {
                    display: 'none',
                },
                [`.${toolbar}`]: {
                    justifyContent: 'center',
                    color: theme.palette.gray[900],
                    fontWeight: 400,
                    border: `1px solid ${theme.palette.gray[300]}`,
                    borderTop: 'none',
                    borderBottomLeftRadius: '1px',
                    borderBottomRightRadius: '1px',
                }
            })
        },
    },
};
exports.default = MuiTablePaginationOverrides;
//# sourceMappingURL=MuiTablePaginationOverrides.js.map